var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "group" },
    [
      !_vm.isRoot && !_vm.isEmpty
        ? _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.group.name))])
        : _vm._e(),
      _vm.addEmpty
        ? _c("app-prop-select-item", {
            key: "empty",
            attrs: { item: _vm.emptyItem, "hovered-value": _vm.hoveredValue },
            on: {
              click: function ($event) {
                return _vm.onClick($event)
              },
            },
          })
        : _vm._e(),
      _vm._l(_vm.items, function (item, i) {
        return _c("app-prop-select-item", {
          key: "i" + i,
          attrs: { item: item, "hovered-value": _vm.hoveredValue },
          on: {
            click: function ($event) {
              return _vm.onClick($event)
            },
          },
        })
      }),
      _vm._l(_vm.group.groups, function (item, i) {
        return _c("app-prop-select-group", {
          key: "g" + i,
          attrs: {
            group: item,
            "search-text": _vm.searchText,
            "hovered-value": _vm.hoveredValue,
          },
          on: {
            click: function ($event) {
              return _vm.onClick($event)
            },
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }